<h1 class="title">{{'TRAVELCARD_LIST_TITLE' |translate}}</h1>
<p class="description">{{'TRAVELCARD_LIST_DESCRIPTION' | translate}}</p>
<div class="card-list-table__travel-card-title">
    <h2>{{'TRAVEL_RELATED_CARDS' | translate}}</h2>
</div>

<div class="card-list-table__travel-card">
    <a [routerLink]="'add' | localize" class="link link--action">
        <span>+ </span>
        <span>{{'ADD_TRAVEL_CARD' | translate}}</span>
    </a>
</div>
